import { render } from "./ListElement.vue?vue&type=template&id=4a972fed&scoped=true"
import script from "./ListElement.vue?vue&type=script&lang=js"
export * from "./ListElement.vue?vue&type=script&lang=js"

import "./ListElement.vue?vue&type=style&index=0&id=4a972fed&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a972fed"]])

export default __exports__